import { render } from "./ChooseEventUser.vue?vue&type=template&id=1ae819c0"
import script from "./ChooseEventUser.vue?vue&type=script&lang=js"
export * from "./ChooseEventUser.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__